let Settings = {
	firstRun: false,
	sound: true,
	icon: true,
	typing: true,
	mention: false,
	messagesStyle: 'compact',
	notifyAll: false,

	save(){
		let obj = {};
		for (let k in this){
			if (!(this[k] instanceof Function)){
				obj[k] = this[k];
			}
		}
		localStorage.chatSettings = JSON.stringify(obj);
	},

	load(){
		this.mention = this.isNotificationPermissionGranted();

		if (localStorage.chatSettings){
			let obj = JSON.parse(localStorage.chatSettings);
			if (obj){
				for (let k in obj){
					if (!(this[k] instanceof Function)){
						this[k] = obj[k];
					}
				}
			}
		}

		this.mention = this.mention && this.isNotificationPermissionGranted();
	},

	isNotificationPermissionGranted(){
		return 'Notification' in window && Notification.permission == 'granted';
	},
};

module.exports = Settings;
